import { render, staticRenderFns } from "./consultCostDialog.vue?vue&type=template&id=24da54c9&"
import script from "./consultCostDialog.vue?vue&type=script&lang=js&"
export * from "./consultCostDialog.vue?vue&type=script&lang=js&"
import style0 from "./consultCostDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports